<header class="feature-header">
  <h3>{{ $content().title }}</h3>
</header>
<div class="description" [innerHtml]="$content().description"></div>
@if (transactionStatus) {
<div class="transaction-status">
  <p [class.is-success]="isSuccessfulSubmission">{{ transactionStatus }}</p>
  @if(!isSuccessfulSubmission){
  <output
    oke-toast
    popover
    id="request-error"
    aria-live="polite"
    title="Submission Error"
    [body]="transactionStatus"
    [support]="{ shouldShowHelpCenter: false }"
  ></output>
  }
</div>
}
<form [formGroup]="manager" (ngSubmit)="onSubmit()">
  <div class="form-item">
    <label for="primary0" class="form-item-label">Your Business w/ONEOK</label>
    @if (primaryItems.length) {
    <div class="is-choices">
      @for (primaryItem of primaryItems; track primaryItem; let primaryItemIdx = $index) {
      <div class="choice">
        <input
          formControlName="primary"
          name="primary"
          type="radio"
          class="choice__input"
          [value]="primaryItem.id"
          [id]="'primary-' + primaryItemIdx"
        />
        <label class="choice__label" [for]="'primary-' + primaryItemIdx">
          <svg-icon src="/assets/svg/circle-dot.svg" />
          <svg-icon src="/assets/svg/circle.svg" />
          <span>{{ primaryItem.label }}</span>
        </label>
      </div>
      }
    </div>
    }
  </div>
  @if (manager.get('primary')?.value && secondaryItems.length) {
  <div class="form-item">
    <label for="secondary0" class="form-item-label">Request Category</label>
    <div class="is-choices">
      @for (secondaryItem of secondaryItems; track secondaryItem; let secondaryItemIdx = $index) {
      <div class="choice">
        <input
          formControlName="secondary"
          name="secondary"
          type="radio"
          class="choice__input"
          [value]="secondaryItem.label"
          [id]="'secondary-' + secondaryItemIdx"
        />
        <label class="choice__label" [for]="'secondary-' + secondaryItemIdx">
          <svg-icon src="/assets/svg/circle-dot.svg" />
          <svg-icon src="/assets/svg/circle.svg" />
          <span>{{ secondaryItem.label }}</span>
        </label>
      </div>
      }
    </div>
  </div>
  } @if (manager.get('secondary')?.value && managerTertiaryItems.length) {
  <div class="form-item">
    <label for="teriary0" class="form-item-label">In what area(s) is your asset(s)?</label>
    <div class="is-choices">
      @for (tertiaryItem of managerTertiaryItems.controls; track tertiaryItem; let tertiaryItemIdx = $index) {
      <div class="choice">
        <input
          type="checkbox"
          class="choice__input"
          [formControl]="$any(tertiaryItem)"
          [value]="true"
          [id]="'tertiary-' + tertiaryItemIdx"
        />
        <label class="choice__label" [for]="'tertiary-' + tertiaryItemIdx">
          @if (!tertiaryItem.value) {
          <svg-icon src="/assets/svg/square.svg" />
          } @if (tertiaryItem.value) {
          <svg-icon src="/assets/svg/square-check-outline.svg" />
          }
          <span>{{ tertiaryItems[ tertiaryItemIdx ].label }}</span>
        </label>
      </div>
      }
    </div>
  </div>
  } @if (manager.get('primary')?.value) {
  <div class="form-item">
    <label for="request-message" class="form-item-label">Message</label>
    <textarea formControlName="message" id="request-message" rows="5"></textarea>
  </div>
  }
  <div class="form-item">
    <button
      type="submit"
      class="oneok-button oneok-blue"
      [disabled]="!manager.valid"
      [class.is-waiting]="this.isInTransit"
    >
      <span>Send my message</span><svg-icon src="/assets/svg/paper-plane.svg" />
    </button>
  </div>
</form>
